import { checkResponse, parseJSONDate } from "src/components/js/statics1";
import gridLogClass from "./gridLogClass";

export async function gridLog_list(ownerAsiakasId, yyyymmdd, token) {
  if (!yyyymmdd || !ownerAsiakasId) return;
  const fullUrl =
    import.meta.env.VITE_SERVER_URL + "/api/grid/log/list/" + yyyymmdd + "/" + ownerAsiakasId;
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(fullUrl, requestOptions);
  const cResponse = await checkResponse(response, "gridLogFunctions.js:gridLog_list");
  if (!cResponse.success) {
    console.log(cResponse);
    return [];
  }
  const result = cResponse.data;
  for (let i = 0; i < result.length; i++) {
    result[i].entryTime = result[i].entryTime == null ? null : parseJSONDate(result[i].entryTime);
  }
  return result;
}

export async function gridLog_add(gridLogClass, token) {
  if (!gridLogClass) return;
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      gridLogTypeId: gridLogClass.gridLogTypeId,
      ownerAsiakasId: gridLogClass.ownerAsiakasId,
      entryByPersonId: gridLogClass.entryByPersonId,
      yyyymmdd: gridLogClass.yyyymmdd,
      keikkaId: gridLogClass.keikkaId,
      vehicleId: gridLogClass.vehicleId,
      personId: gridLogClass.personId,
      selite: gridLogClass.selite,
      comments: gridLogClass.comments,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/grid/log/add",
    requestOptions
  ).catch((error) => console.log(error));
  return response.ok;
}

export async function gridLog_delete(gridLogId, token) {
  if (!gridLogId) return;
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/grid/log/delete/" + gridLogId;
  const requestOptions = {
    method: "DELETE",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(fullUrl, requestOptions);
  return response.ok;
}

export async function gridLog_add_pumppariAddedToKeikka(
  personId,
  keikkaId,
  vehicleId,
  ownerAsiakasId,
  yyyymmdd,
  token
) {
  const _gridLogClass = new gridLogClass();
  _gridLogClass.gridLogTypeId = 1;
  _gridLogClass.ownerAsiakasId = ownerAsiakasId;
  _gridLogClass.personId = personId;
  _gridLogClass.vehicleId = vehicleId;
  _gridLogClass.yyyymmdd = yyyymmdd;
  _gridLogClass.keikkaId = keikkaId;
  _gridLogClass.selite = "Kuljettaja lisätty tilaukseen";
  return await gridLog_add(_gridLogClass, token);
}

export async function gridLog_add_pumppariRemovedFromKeikka(
  personId,
  keikkaId,
  vehicleId,
  ownerAsiakasId,
  yyyymmdd,
  token
) {
  if (!personId || !keikkaId) return false;
  const _gridLogClass = new gridLogClass();
  _gridLogClass.gridLogTypeId = 2;
  _gridLogClass.ownerAsiakasId = ownerAsiakasId;
  _gridLogClass.personId = personId;
  _gridLogClass.yyyymmdd = yyyymmdd;
  _gridLogClass.vehicleId = vehicleId;
  _gridLogClass.keikkaId = keikkaId;
  _gridLogClass.selite = "Kuljettaja poistettu tilauksesta";
  return await gridLog_add(_gridLogClass, token);
}

export async function gridLog_add_setPumppariAsVehicleDayDriver(
  personId,
  vehicleId,
  ownerAsiakasId,
  yyyymmdd,
  token
) {
  const _gridLogClass = new gridLogClass();
  _gridLogClass.gridLogTypeId = 3;
  _gridLogClass.ownerAsiakasId = ownerAsiakasId;
  _gridLogClass.personId = personId;
  _gridLogClass.yyyymmdd = yyyymmdd;
  _gridLogClass.vehicleId = vehicleId;
  _gridLogClass.keikkaId = null;
  _gridLogClass.selite = "Kuljettaja asetettu päivän kuljettajaksi ajoneuvolle";
  return await gridLog_add(_gridLogClass, token);
}

export async function gridLog_add_setKeikkaToVehicle(
  keikkaId,
  vehicleId,
  ownerAsiakasId,
  yyyymmdd,
  token,
  selite = null
) {
  const _gridLogClass = new gridLogClass();
  _gridLogClass.gridLogTypeId = 4; // Tilaus autolle
  _gridLogClass.ownerAsiakasId = ownerAsiakasId;
  _gridLogClass.yyyymmdd = yyyymmdd;
  _gridLogClass.vehicleId = vehicleId;
  _gridLogClass.keikkaId = keikkaId;
  if (selite === null) _gridLogClass.selite = "Tilaus siirretty ajoneuvolle";
  else _gridLogClass.selite = selite;
  return await gridLog_add(_gridLogClass, token);
}

export async function gridLog_add_setKeikkaTilaId(keikka, token) {
  const _gridLogClass = new gridLogClass();
  _gridLogClass.gridLogTypeId = 5; // Keikka tila
  _gridLogClass.ownerAsiakasId = keikka.ownerAsiakasId;
  _gridLogClass.yyyymmdd = keikka.yyyymmdd;
  _gridLogClass.vehicleId = keikka.vehicleId;
  _gridLogClass.keikkaId = keikka.keikkaId;
  _gridLogClass.selite = "Tilaus asetettu tilaan:" + keikka.keikkaTilaSelite;
  return await gridLog_add(_gridLogClass, token);
}

export async function gridLog_add_setPumppuAika(keikka, token, selite = null) {
  const _gridLogClass = new gridLogClass();
  _gridLogClass.gridLogTypeId = 6; // Pumppu aika
  _gridLogClass.ownerAsiakasId = keikka.ownerAsiakasId;
  _gridLogClass.yyyymmdd = keikka.yyyymmdd;
  _gridLogClass.vehicleId = keikka.vehicleId;
  _gridLogClass.keikkaId = keikka.keikkaId;
  if (selite === null) _gridLogClass.selite = "Toimitusaika ja kesto asetettu";
  else _gridLogClass.selite = selite;
  return await gridLog_add(_gridLogClass, token);
}
